_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[25],{

/***/ "/EDR":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("23aj");
      }
    ]);
  

/***/ }),

/***/ "23aj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__N_SSP", function() { return __N_SSP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Pages; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g4pe");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("YFqc");
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_UseLoggedIn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qdsK");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("20a2");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_UserPage_UserPage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("i3no");

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var indexStyles = __webpack_require__("d/HE");

var __N_SSP = true;
function Pages(props) {
  var _useLoggedIn = Object(_lib_UseLoggedIn__WEBPACK_IMPORTED_MODULE_3__[/* useLoggedIn */ "d"])(),
      authenticated = _useLoggedIn.authenticated,
      error = _useLoggedIn.error,
      loading = _useLoggedIn.loading;

  var indexPage = props.indexPage,
      profileUsername = props.profileUsername,
      profileData = props.profileData,
      errored = props.errored,
      uid = props.uid,
      posts = props.posts,
      onCustomDomain = props.onCustomDomain,
      userHost = props.userHost;

  if (authenticated && indexPage) {
    console.log("redirecting to landing");
    window.location.href = "/landing";
  }

  return __jsx("div", {
    className: indexStyles["container"]
  }, __jsx(next_head__WEBPACK_IMPORTED_MODULE_1___default.a, null, __jsx("title", null, "Leaf"), __jsx("link", {
    rel: "icon",
    href: "/favicon.ico"
  }), indexPage && __jsx("script", {
    dangerouslySetInnerHTML: {
      __html: "\n          if (document.cookie && document.cookie.includes('authed')) {\n            window.location.href = \"/landing\"\n          }\n        "
    }
  })), indexPage ? __jsx(IndexPage, null) : __jsx(_components_UserPage_UserPage__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], {
    profileData: profileData,
    errored: errored,
    posts: posts,
    uid: uid,
    profileUsername: profileUsername,
    onCustomDomain: onCustomDomain,
    userHost: userHost
  }));
}

function IndexPage() {
  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_4__["useRouter"])();

  var goToIndex = function goToIndex(e) {
    e.preventDefault();
    router.push("/");
  };

  return __jsx("main", {
    className: indexStyles["MainWrapper"]
  }, __jsx(Header, {
    goToIndex: goToIndex
  }), __jsx(HeaderDropDown, {
    goToIndex: goToIndex
  }), __jsx(Stripe1, null), __jsx(Title, null), __jsx(Row1, null), __jsx(Row2, null), __jsx(Row3, null), __jsx(Row4, null), __jsx(Footer, {
    goToIndex: goToIndex
  }));
}
/*
Header Components
*/


function Header(props) {
  return __jsx("div", {
    className: indexStyles["IndexHeader"]
  }, __jsx(NavBar, {
    goToIndex: props.goToIndex
  }));
}

function NavBar(props) {
  return __jsx("div", {
    className: indexStyles["IndexNavBar"]
  }, __jsx(Logo, {
    goToIndex: props.goToIndex
  }), __jsx(Signup, null), __jsx(Login, null), __jsx(Explore, null), __jsx(About, null));
}

function HeaderDropDown(props) {
  return __jsx("div", {
    className: indexStyles["HeaderDropDown"]
  }, __jsx(NavBarDropDown, {
    goToIndex: props.goToIndex
  }));
}

function NavBarDropDown(props) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      opened = _useState[0],
      toggleOpen = _useState[1];

  return __jsx("div", {
    className: indexStyles["NavBarDropDown"]
  }, __jsx(Logo, {
    goToIndex: props.goToIndex
  }), __jsx("div", {
    className: indexStyles["dropdown"]
  }, __jsx("button", {
    onClick: function onClick(e) {
      return toggleOpen(!opened);
    },
    className: "dropbtn"
  }, "\u2630"), __jsx("div", {
    className: indexStyles["dropdownContent"]
  }, opened ? __jsx("div", null, __jsx(Signup, null), __jsx(Login, null), __jsx(Explore, null), __jsx(About, null)) : __jsx("div", null))));
}

function Logo(props) {
  return __jsx("div", {
    className: indexStyles["Logo"],
    onClick: props.goToIndex
  }, __jsx("img", {
    src: "/images/logo.svg"
  }));
}

function Login() {
  return __jsx("div", {
    className: indexStyles["Login"]
  }, __jsx(next_link__WEBPACK_IMPORTED_MODULE_2___default.a, {
    href: "/login"
  }, __jsx("a", null, "Login")));
}

function Signup() {
  return __jsx("div", {
    className: indexStyles["Login"]
  }, __jsx(next_link__WEBPACK_IMPORTED_MODULE_2___default.a, {
    href: "/signup"
  }, __jsx("a", null, "Signup")));
}

function Explore() {
  return __jsx("div", {
    className: indexStyles["Login"]
  }, __jsx(next_link__WEBPACK_IMPORTED_MODULE_2___default.a, {
    href: "/explore"
  }, __jsx("a", null, "Explore")));
}

function About() {
  return __jsx("div", {
    className: indexStyles["Login"]
  }, __jsx(next_link__WEBPACK_IMPORTED_MODULE_2___default.a, {
    href: "/about"
  }, __jsx("a", null, "About")));
}

function Title() {
  return __jsx("div", {
    className: indexStyles["Title"]
  }, __jsx(TitleText, null));
}

function TitleText() {
  return __jsx("div", {
    className: indexStyles["Title"]
  }, __jsx("div", {
    className: indexStyles["Banner"]
  }, __jsx("div", {
    className: indexStyles["Text"]
  }, __jsx("div", {
    className: indexStyles["h1Text"]
  }, "Leaf is a platform built from the ground up, for coding tutorials"), __jsx("div", {
    className: indexStyles["h2Text"]
  }, "Say goodbye to publishing code snippets on Medium"), __jsx("div", {
    className: indexStyles["TitleButtons"]
  }, __jsx(next_link__WEBPACK_IMPORTED_MODULE_2___default.a, {
    href: "/signup"
  }, __jsx("div", {
    className: indexStyles["GetStarted"]
  }, __jsx("div", {
    className: indexStyles["button"]
  }, "Get Started", __jsx("img", {
    src: "/images/warrow.svg"
  })))), __jsx(next_link__WEBPACK_IMPORTED_MODULE_2___default.a, {
    href: "/explore"
  }, __jsx("div", {
    className: indexStyles["Explore"]
  }, __jsx("div", {
    className: indexStyles["button"]
  }, "Learn More", __jsx("img", {
    src: "/images/arrow.svg"
  })))))), __jsx("div", {
    className: indexStyles["computer"]
  }, __jsx("img", {
    src: "/images/laptop3.svg"
  }), __jsx("div", {
    className: indexStyles["screen"]
  }, __jsx("video", {
    className: indexStyles["demo"],
    autoPlay: true,
    muted: true,
    loop: true
  }, __jsx("source", {
    src: "/videos/frontpage.mp4"
  }))))));
}

function GetStarted2() {
  return __jsx(next_link__WEBPACK_IMPORTED_MODULE_2___default.a, {
    href: "/signup"
  }, __jsx("div", {
    className: indexStyles["GetStarted2"]
  }, __jsx("div", {
    className: indexStyles["button"]
  }, "Sign Up")));
}

function Row1() {
  return __jsx("div", {
    className: indexStyles["Row1"]
  }, __jsx("div", {
    className: indexStyles["RowHeader"]
  }, __jsx("img", {
    src: "/images/steps.svg"
  })), __jsx("div", {
    className: indexStyles["Screen"]
  }, __jsx("video", {
    className: indexStyles["Demo"],
    autoPlay: true,
    muted: true,
    loop: true
  }, __jsx("source", {
    src: "/videos/steps.mp4"
  }))));
}

function Row2() {
  return __jsx("div", {
    className: indexStyles["Row2"]
  }, __jsx(Stripe2, null), __jsx("div", {
    className: indexStyles["Row2Header"]
  }, __jsx("img", {
    src: "/images/code.svg"
  })), __jsx("div", {
    className: indexStyles["Screen"]
  }, __jsx("video", {
    className: indexStyles["Demo"],
    autoPlay: true,
    muted: true,
    loop: true
  }, __jsx("source", {
    src: "/videos/code.mp4"
  }))));
}

function Row3() {
  return __jsx("div", {
    className: indexStyles["Row3"]
  }, __jsx("div", {
    className: indexStyles["RowHeader"]
  }, __jsx("img", {
    src: "/images/publish.svg"
  })), __jsx("div", {
    className: indexStyles["Screen"]
  }, __jsx("video", {
    className: indexStyles["Demo"],
    autoPlay: true,
    muted: true,
    loop: true
  }, __jsx("source", {
    src: "/videos/scroll.mp4"
  }))));
}

function Row4() {
  return __jsx("div", {
    className: indexStyles["Row4"]
  }, __jsx(Stripe3, null), __jsx("div", {
    className: indexStyles["Row4Text"]
  }, "Start making beautiful tutorials with Leaf"), __jsx(GetStarted2, null));
}

function Footer(props) {
  return __jsx("div", {
    className: indexStyles["IndexFooter"]
  }, __jsx("div", {
    className: indexStyles["FooterNavBar"]
  }, __jsx(Logo, {
    goToIndex: props.goToIndex
  }), __jsx(Signup, null), __jsx(Login, null), __jsx(Explore, null), __jsx(About, null)));
}

function Stripe1() {
  return __jsx("div", {
    className: indexStyles["Stripe1"]
  });
}

function Stripe2() {
  return __jsx("div", {
    className: indexStyles["Stripe2"]
  });
}

function Stripe3() {
  return __jsx("div", {
    className: indexStyles["Stripe3"]
  });
}

/***/ }),

/***/ "d/HE":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"IndexHeader":"styles_IndexHeader__35XNX","HeaderDropDown":"styles_HeaderDropDown__-DgW4","Title":"styles_Title__2LXU1","Banner":"styles_Banner__3RuzL","Text":"styles_Text__3OhuH","h1Text":"styles_h1Text__jf0iS","h2Text":"styles_h2Text__1CA5H","TitleButtons":"styles_TitleButtons__2FxLo","GetStarted":"styles_GetStarted__ScISs","Explore":"styles_Explore__2BR4T","computer":"styles_computer__k9ADr","screen":"styles_screen__ZWSKc","Stripe1":"styles_Stripe1__22UWG","Stripe2":"styles_Stripe2__3JSWs","Stripe3":"styles_Stripe3__1dHZS","IndexFooter":"styles_IndexFooter__2gNJd","FooterNavBar":"styles_FooterNavBar__2R8O2","Logo":"styles_Logo__1PgIc","Login":"styles_Login__9WdDl","container":"styles_container__3yd9V","MainWrapper":"styles_MainWrapper__3wFDp","IndexNavBar":"styles_IndexNavBar__2ciO9","NavBarDropDown":"styles_NavBarDropDown__2NMR1","dropdown":"styles_dropdown__2hd69","dropbtn":"styles_dropbtn__3fRa8","dropdownContent":"styles_dropdownContent__2rnA7","demo":"styles_demo__1J8E1","Row1":"styles_Row1__3_RS5","RowHeader":"styles_RowHeader__1EU30","Row2":"styles_Row2__eaJE-","Row2Header":"styles_Row2Header__1A9vv","Row3":"styles_Row3__3Fpa5","Row4":"styles_Row4__29hv0","Row4Text":"styles_Row4Text__rMSXz","GetStarted2":"styles_GetStarted2__3gmEb","Screen":"styles_Screen__1oKnG","Demo":"styles_Demo__1c90s"};

/***/ }),

/***/ "iTpk":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"add-image":"imageview_add-image__1QNH7","remove-button":"imageview_remove-button__1o6rc","img-view":"imageview_img-view__27sbb","preview":"imageview_preview__1hMyj","togglePreview":"imageview_togglePreview__3xfwE","previewButtons":"imageview_previewButtons__qdqhq","submit":"imageview_submit__1B1Y1","submitButtons":"imageview_submitButtons__3PKVI","published-img":"imageview_published-img__2V3pA","options-wrapper":"imageview_options-wrapper__1krJd","title-with-divider":"imageview_title-with-divider__a4GF2"};

/***/ })

},[["/EDR",0,2,5,1,3,4,6,8,11,12]]]);